export default __webpack_public_path__ + "static/media/why1.203b1954.png";